import styled from 'styled-components'

export const ProgrammingIcon = styled.div`
  margin-top: 16px;
  margin-bottom: 32px;
  img {
    margin: 2px;
  }
`
